







import { defineComponent, getCurrentInstance, onMounted, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useEmailVerification from "@/hooks/useEmailVerification";
import providers from "@/lib/api";
import { getProfileUrl } from "@/lib/urlHelpers";
import BasePage from "@/components/BasePage";
import SignUpEmailConfirmCode from "@/components/SignUpEmailConfirmCode";
import ConfirmCodeView from "@/views/PageEmailConfirmCode/components/ConfirmCodeView.vue";

export default defineComponent({
  name: "PageEmailConfirmCode",
  components: { ConfirmCodeView, SignUpEmailConfirmCode, BasePage },
  props: {
    code: {
      type: String,
    },
  },
  setup(props) {
    const { authUserStrict, authUser } = useAuthUser();
    const { startPeriodicalConfirmationCheck, setUserVerificationStatus } = useEmailVerification();
    const vm = getCurrentInstance();

    const loading = ref(false);
    const success = ref(false);

    const onLogout = () => {
      vm?.$router.push({ name: "logout" });
    };
    const onLogin = () => {
      vm?.$router.push(getProfileUrl(authUserStrict.value));
    };

    const sendConfirmationCode = async () => {
      if (!props.code) return;
      try {
        loading.value = true;
        success.value = await providers.EmailVerificationProvider.verifyByLongCode({ code: props.code });
        if (authUser.value && success.value) {
          await setUserVerificationStatus(success.value);
        }
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      if (!props.code) {
        startPeriodicalConfirmationCheck(onLogin);
      } else {
        sendConfirmationCode();
      }
    });

    return {
      loading,
      success,
      onLogout,
      onLogin,
    };
  },
});
